import React, { useEffect, useRef } from 'react';
import { LayoutDashboardIcon, CheckCircleIcon, SmartphoneIcon, GlobeIcon, AwardIcon, ClipboardCheckIcon, RefreshCwIcon, BuildingIcon } from 'lucide-react';
export const ValueSection = () => {
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-fade-in');
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="py-24 bg-white opacity-0 transition-opacity duration-1000" data-id="element-1360">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1361">
        <div className="max-w-4xl mx-auto mb-14 text-center" data-id="element-1362">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-charcoal tracking-tight" data-id="element-1363">
            Premium Benefits. Unmatched Value.
          </h2>
          <p className="text-xl text-gray-600 max-w-[720px] mx-auto" data-id="element-1364">
            Industry-leading features that set our compliance training apart
          </p>
        </div>
        <div className="max-w-6xl mx-auto grid grid-cols-12 gap-6" data-id="element-1365">
          {/* Row 1 */}
          {/* Manager Dashboard - 6 cols */}
          <div className="col-span-6 row-span-2 rounded-[20px] bg-charcoal overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all hover:shadow-lg hover:-translate-y-1 duration-300 relative" data-id="element-1366">
            <div className="absolute inset-0 bg-cover bg-center opacity-15 mix-blend-overlay" style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1542744173-05336fcc7ad4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80')"
          }} data-id="element-1367"></div>
            <div className="p-8 h-full relative z-10" data-id="element-1368">
              <div className="mb-6 inline-flex items-center justify-center w-10 h-10 rounded-lg bg-white/10" data-id="element-1369">
                <LayoutDashboardIcon className="h-5 w-5 text-white" data-id="element-1370" />
              </div>
              <h3 className="text-[22px] font-bold mb-3 text-white" data-id="element-1371">
                Manager Dashboard
              </h3>
              <p className="text-white/80 text-[15px]" data-id="element-1372">
                Assign training, track progress, export reports—all in one
                place.
              </p>
            </div>
          </div>
          {/* Recognized Certificates - 3 cols */}
          <div className="col-span-3 row-span-2 rounded-[20px] bg-charcoal overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-1373">
            <div className="p-8 h-full flex flex-col" data-id="element-1374">
              <div className="text-[80px] font-bold text-white mb-2 leading-tight" data-id="element-1375">
                100%
              </div>
              <h3 className="text-[22px] font-bold mb-3 text-white" data-id="element-1376">
                Recognized Certificates
              </h3>
              <p className="text-white/80 text-[15px]" data-id="element-1377">
                Guaranteed acceptance by regulators and industry standards.
              </p>
            </div>
          </div>
          {/* Mobile App - 3 cols */}
          <div className="col-span-3 row-span-2 rounded-[20px] bg-white overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-1378">
            <div className="p-8 h-full" data-id="element-1379">
              <div className="mb-6 inline-flex items-center justify-center w-10 h-10 rounded-lg bg-charcoal/10" data-id="element-1380">
                <SmartphoneIcon className="h-5 w-5 text-charcoal" data-id="element-1381" />
              </div>
              <h3 className="text-[22px] font-bold mb-3 text-charcoal" data-id="element-1382">
                Mobile App
              </h3>
              <p className="text-charcoal/80 text-[15px]" data-id="element-1383">
                Train and manage on the go with our iOS & Android app.
              </p>
            </div>
          </div>
          {/* Row 2 */}
          {/* Region-Specific Compliance - 3 cols */}
          <div className="col-span-3 row-span-2 rounded-[20px] bg-white overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-1384">
            <div className="p-8 h-full" data-id="element-1385">
              <div className="mb-6 inline-flex items-center justify-center w-10 h-10 rounded-lg bg-charcoal/10" data-id="element-1386">
                <GlobeIcon className="h-5 w-5 text-charcoal" data-id="element-1387" />
              </div>
              <h3 className="text-[22px] font-bold mb-3 text-charcoal" data-id="element-1388">
                Region-Specific Compliance
              </h3>
              <p className="text-charcoal/80 text-[15px]" data-id="element-1389">
                Built for Irish, UK & EU legislation—always audit-ready.
              </p>
            </div>
          </div>
          {/* Certificate Guarantee - 3 cols */}
          <div className="col-span-3 row-span-2 rounded-[20px] bg-teal overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-1390">
            <div className="p-8 h-full flex flex-col" data-id="element-1391">
              <div className="flex justify-between items-start mb-6" data-id="element-1392">
                <div className="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-white/10" data-id="element-1393">
                  <AwardIcon className="h-5 w-5 text-white" data-id="element-1394" />
                </div>
                <span className="px-2.5 py-0.5 text-xs font-medium bg-aqua text-white rounded-full flex items-center" data-id="element-1395">
                  Exclusive
                </span>
              </div>
              <h3 className="text-[22px] font-bold mb-3 text-white" data-id="element-1396">
                Certificate Guarantee
              </h3>
              <p className="text-white/80 text-[15px]" data-id="element-1397">
                If a certificate is refused, we'll refund you. T&Cs apply.
              </p>
            </div>
          </div>
          {/* Compliance Records - 3 cols */}
          <div className="col-span-3 row-span-2 rounded-[20px] bg-charcoal overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-1398">
            <div className="p-8 h-full" data-id="element-1399">
              <div className="mb-6 inline-flex items-center justify-center w-10 h-10 rounded-lg bg-white/10" data-id="element-1400">
                <ClipboardCheckIcon className="h-5 w-5 text-white" data-id="element-1401" />
              </div>
              <h3 className="text-[22px] font-bold mb-3 text-white" data-id="element-1402">
                Compliance Records
              </h3>
              <p className="text-white/80 text-[15px]" data-id="element-1403">
                Centralized storage for certificates, reports, and
                logs—inspection-ready.
              </p>
            </div>
          </div>
          {/* Enterprise Academy - 3 cols */}
          <div className="col-span-3 row-span-4 rounded-[20px] bg-charcoal overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-1404">
            <div className="p-8 h-full flex flex-col" data-id="element-1405">
              <div className="mb-6 inline-flex items-center justify-center w-10 h-10 rounded-lg bg-white/10" data-id="element-1406">
                <BuildingIcon className="h-5 w-5 text-white" data-id="element-1407" />
              </div>
              <h3 className="text-[22px] font-bold mb-3 text-white" data-id="element-1408">
                Enterprise Academy
              </h3>
              <p className="text-white/80 text-[15px] mb-6" data-id="element-1409">
                Your own white-label academy—custom domain, onboarding, advanced
                reporting.
              </p>
              <div className="flex flex-wrap gap-3 mt-auto" data-id="element-1410">
                <div className="h-[60px] w-[64px] bg-white/10 rounded-lg" data-id="element-1411"></div>
                <div className="h-[60px] w-[64px] bg-white/10 rounded-lg" data-id="element-1412"></div>
                <div className="h-[60px] w-[64px] bg-white/10 rounded-lg" data-id="element-1413"></div>
                <div className="h-[60px] w-[64px] bg-white/10 rounded-lg" data-id="element-1414"></div>
              </div>
            </div>
          </div>
          {/* Row 3 */}
          {/* Unlimited Retries - 3 cols */}
          <div className="col-span-3 row-span-2 rounded-[20px] bg-white overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-1415">
            <div className="p-8 h-full" data-id="element-1416">
              <div className="mb-6 inline-flex items-center justify-center w-10 h-10 rounded-lg bg-charcoal/10" data-id="element-1417">
                <RefreshCwIcon className="h-5 w-5 text-charcoal" data-id="element-1418" />
              </div>
              <h3 className="text-[22px] font-bold mb-3 text-charcoal" data-id="element-1419">
                Unlimited Retries
              </h3>
              <p className="text-charcoal/80 text-[15px]" data-id="element-1420">
                Never locked out—practice until you're confident and ready.
              </p>
            </div>
          </div>
          {/* Completion Tracking - 3 cols */}
          <div className="col-span-3 row-span-2 rounded-[20px] bg-white overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-1421">
            <div className="p-8 h-full" data-id="element-1422">
              <div className="mb-6 inline-flex items-center justify-center w-10 h-10 rounded-lg bg-charcoal/10" data-id="element-1423">
                <CheckCircleIcon className="h-5 w-5 text-charcoal" data-id="element-1424" />
              </div>
              <h3 className="text-[22px] font-bold mb-3 text-charcoal" data-id="element-1425">
                Completion Tracking
              </h3>
              <p className="text-charcoal/80 text-[15px]" data-id="element-1426">
                Real-time progress tracking with detailed completion analytics.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-1427">
          <div className="inline-block py-2 px-5 bg-gray-50 rounded-full" data-id="element-1428">
            <span className="text-charcoal font-medium text-sm" data-id="element-1429">
              <span className="text-teal" data-id="element-1430">Trusted by</span> 1000+ businesses
              across Europe
            </span>
          </div>
        </div>
      </div>
    </section>;
};